import React from 'react'
import styled from 'styled-components'
import Link, { handleHoverStyleLinkType, handleStyleLinkType } from 'ui/Link'

interface PreviewBlockProps {
  title?: string
  preview: string
  text?: string
  buttonLabel?: string
  href?: string
  percentPrefix: string
  payout: string
  isGridArea?: boolean
}

const DropdownNavPreviewBlock: React.FC<PreviewBlockProps> = props => {
  const {
    title,
    preview,
    // text,
    buttonLabel = '',
    href = '',
    percentPrefix,
    // payout
  } = props
  return (
    <Container>
      <Preview src={preview} alt={title} />
      <Title>
        {title} <PercentPrefix>{percentPrefix}</PercentPrefix>
      </Title>
      <StyledLink type={'tertiary'} to={href}>
        {buttonLabel}
      </StyledLink>
      {/* <Text>{text}</Text>
      <Payout>{payout}</Payout> */}
    </Container>
  )
}

export default DropdownNavPreviewBlock

const Container = styled.section`
  display: block;
  background: linear-gradient(180deg, #1743a7 0%, #1743a7 100%);
  padding: 2rem;
  text-align: start;
  border-radius: 0 0.5rem 0.5rem 0;

  @media ${({ theme }) => theme.device.xxmMax} {
    display: none;
  }
`

const Preview = styled.img`
  max-width: 115px;
  max-height: 125px;
  margin-bottom: 0.875rem;
`

const Title = styled.h4`
  color: ${({ theme: { colors } }) => colors.newLightColor.white};
  font-weight: 700;
  font-size: 1rem;
  text-align: start;

  margin-bottom: 0.75rem;
`

const PercentPrefix = styled.span`
  color: ${({ theme: { colors } }) => colors.newLightColor.brightGreen};
`

const StyledLink = styled(Link)`
  width: 175px;
  margin-bottom: 1rem;
  margin: 0;

  text-transform: none;

  ${handleStyleLinkType('tertiary')}
  &:hover {
    ${handleHoverStyleLinkType('tertiary')}
  }
`

// const Text = styled.p`
//   font-size: 0.875rem;
//   letter-spacing: 0.02em;
//   font-weight: 400;
//   line-height: 21px;
//   color: ${({ theme: { colors } }) => colors.white};
//   margin: 0;
//   margin-top: 1rem;
// `

// const Payout = styled.p`
//   color: ${({ theme: { colors } }) => colors.newLightColor.brightGreen};
//   font-weight: 700;
//   font-size: 1rem;
//   margin: 0;
// `
